//jewelery
export const FETCH_JEWELERY_REQUEST = "FETCH_JEWELERY_REQUEST";
export const FETCH_JEWELERY_SUCCESS = "FETCH_JEWELERY_SUCCESS";
export const FETCH_JEWELERY_FAILED = "FETCH_JEWELERY_FAILED";

//electronics
export const FETCH_ELECTRONIC_REQUEST = "FETCH_ELECTRONIC_REQUEST";
export const FETCH_ELECTRONIC_SUCCESS = "FETCH_ELECTRONIC_SUCCESS";
export const FETCH_ELECTRONIC_FAILED = "FETCH_ELECTRONIC_FAILED";
